import { IconButton, Dropdown, Menu, MenuItemProps, Dialog, useTranslations, useGraphqlDelete, useListGraphqlQuery, useUrlParamsValueToString, useTranslationRoute } from "@bsm/component";
import { useState } from "react";
import { TUserStudentScholarity } from "@bsm/graphql";
import { useNavigate } from "react-router-dom";
import { DeleteScholarityDialog } from "./DeleteScholarityDialog";
import { useLineMenu } from "views/list/queries/useLineMenu";

export const ScholarityInlineMenu = (props: Partial<TUserStudentScholarity>) => {

    const [menuState, setMenuState] = useState<{ anchorEl: HTMLElement | null; id: number | null }>({
        anchorEl: null,
        id: null,
    });
    const [isDialogOpenDeleteLine, setIsDialogOpenDeleteLine] = useState(false);
    const navigate = useNavigate();
    const tr = useTranslationRoute()
    const urlParams = useUrlParamsValueToString()
    const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>, id: number) => {
        setMenuState({ anchorEl: event.currentTarget, id });
    };
    const handleCloseMenu = () => {
        setMenuState((prevState) => ({ ...prevState, anchorEl: null }));
    };
    const menuEllipsisItems = useLineMenu();

    const handleMenuClick = (menu: MenuItemProps) => {
        if (menu.ke === "edit") {
            navigate(`${props.id}/edit?${urlParams}`)
        }
        if (menu.ke === "delete") { setIsDialogOpenDeleteLine(true) }
        handleCloseMenu();
    }

    const handleCloseDialogDeleteLine = () => {
        setIsDialogOpenDeleteLine(false);
    };

    return (
        <div>
            <IconButton
                icon={"fa-ellipsis"}
                onClick={(e) => handleOpenMenu(e, props.id)}
            />
            {menuState.id === props.id && (
                <Dropdown
                    anchorEl={menuState.anchorEl}
                    arrow
                    placement="bottom-end"
                    onClose={handleCloseMenu}
                >
                    <Menu
                        items={menuEllipsisItems}
                        showFn={(menu) => {
                            if (menu.ke === "edit") {
                                return props.isEditable as any;
                            }
                            if (menu.ke === "delete") {
                                return props.isDeletable as any;
                            }
                        }}
                        onClick={handleMenuClick}
                    />
                </Dropdown>
            )}

            <DeleteScholarityDialog id={props?.id} open={isDialogOpenDeleteLine} onClose={handleCloseDialogDeleteLine} />
        </div>
    )
}